module.exports = __webpack_public_path__ + "static/media/NOLTopUp.97410ba0.svg";